import React from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

//Assets
import "./notFound.scss";
import { ArrowIcon } from "assets/svg/MarkIcon";

const NotFound = ({ t }) => {
    return (
        <div className="NotFound">
            <p className="NotFound-text">404 not found</p>
            <p className="NotFound-text">
                <Link to="/">
                    {t("common.components.notFound.link")} <ArrowIcon />
                </Link>
            </p>
        </div>
    );
};

export default withTranslation()(NotFound);
